import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const oraGloss: Collection = {
  id: 's-and-p-ora-gloss',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Ora Gloss',
  subTitle: 'Stijlvol en feestelijk',
  banner: 'ora-gloss/ora_gloss_banner.jpg',
  items: [
    {
      id: 's-and-p-ora-gloss-1',
      collectionImages: [
        {
          image: 'ora-gloss/Ora_gloss_blossom_aura_tabletop_01.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'ora-gloss/Ora_gloss_blossom_aura_tabletop_lifestyle_06.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-ora-gloss-2',
      collectionImages: [
        {
          image: 'ora-gloss/Ora_gloss_blossom_aura_tabletop_lifestyle_07.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    'a19d7f85-d551-461d-81cb-ea2f964b7576',
    'b216abb1-a642-4ccd-9bc7-3410c850d0aa',
    '330aa9d8-5644-4e30-b336-b659e96b544a',
    '18f157f9-1dc3-4d40-992f-e8e1026e21d2',
    'ac1171f3-5ccd-4a24-8d32-1468a799c3dd',
    '0155f8c1-9e56-4781-8809-5a42b0eb6e27',
    'c03abccf-ce09-4b35-b1d4-7fe6814bf716',
    '32aa9398-a8ad-478b-82b8-05da98e5626d'
  ]
};
